import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { cn } from "@/lib/utils";

export function Btn({ variant = "primary", as = "button", to, href, className, children, ...props }) {
  const base = "inline-flex items-center justify-center gap-2 rounded-full font-bold px-7 py-3.5 text-base transition-[background-color,transform,box-shadow] duration-300 ease-out cursor-pointer";
  const variants = {
    primary: "bg-vs-orange text-white shadow-vs-soft hover:bg-vs-green hover:-translate-y-0.5 hover:shadow-vs-lift",
    green: "bg-vs-green text-white shadow-vs-card hover:bg-vs-orange hover:-translate-y-0.5 hover:shadow-vs-lift",
    secondary: "bg-transparent border-2 border-vs-green text-vs-green hover:bg-vs-green hover:text-white hover:-translate-y-0.5",
    outlineOrange: "bg-transparent border-2 border-vs-orange text-vs-orange hover:bg-vs-orange hover:text-white hover:-translate-y-0.5",
    white: "bg-vs-card text-vs-text shadow-vs-soft hover:bg-vs-peach hover:-translate-y-0.5",
  };
  const cls = cn(base, variants[variant], className);
  if (to) return <Link to={to} className={cls} {...props}>{children}</Link>;
  if (href) return <a href={href} className={cls} {...props}>{children}</a>;
  return <button className={cls} {...props}>{children}</button>;
}

export function TextLink({ to, href, children, className, ...props }) {
  const cls = cn(
    "text-vs-green font-bold hover:text-vs-orange transition-colors inline-flex items-center gap-2 group",
    className
  );
  const inner = (
    <>
      {children}
      <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" strokeWidth={2} />
    </>
  );
  if (to) return <Link to={to} className={cls} {...props}>{inner}</Link>;
  return <a href={href} className={cls} {...props}>{inner}</a>;
}
